import {PaginaLogada} from "../componentes";
import {Card} from "../componentes/card/Card";
import {useEffect, useState} from "react";
import {Link, useSearchParams} from "react-router-dom";
import {exibirMensagemErro, HttpVerbo, xfetch} from "../util";

export default function Busca() {

  const [isCarregando, setIsCarregando] = useState(false)
  const [params] = useSearchParams()
  const [projetos, setProjetos] = useState([])
  const [metas, setMetas] = useState([])
  const [arquivosHistorico, setArquivosHistorico] = useState([])


  const buscar = () => {
    setIsCarregando(true)
    xfetch(`/busca?termo=${params.get('q')}`, {}, HttpVerbo.GET)
      .then(res => res.json())
      .then(json => setProjetos(json.projetos) & setMetas(json.metas) & setArquivosHistorico(json.buscaHitoricoAsplan))
      .finally(() => setIsCarregando(false))
      .catch((_e) => exibirMensagemErro("Erro ao realizar consulta"))
  }

  useEffect(() => {
    buscar()
  }, [params.get('q')])

  function semResultados() {
    return (
      <ul>
        <li className="list-unstyled">Sem resultado</li>
      </ul>
    );
  }

  function mapeandoProjetos() {
    if (projetos.length === 0) {
      return semResultados()
    }

    return projetos.map((v, _k) => {
      return (
        <li key={v.idProjeto} className="list-unstyled">
          <Link to={'/projeto/' + v.idProjeto}>
            Convênio - {v.convenio === params.get('q') ? <b> {v.convenio} </b> : v.convenio} |
            IGESP - {v.igesp === params.get('q') ? <b> {v.igesp} </b> : v.igesp} |
            Objeto - {v.titulo.substring(0, 30) + '...'}
          </Link>
        </li>)

    });
  }

  function mapeandoMetas() {
    if (metas.length === 0) {
      return semResultados()
    }

    return metas.map((v, k) => {
      return (
        <li key={k} className="list-unstyled">
          <Link to={`/projeto/${v.idProjeto}/meta/${v.idMeta}`}>
            Meta - {v.titulo}
          </Link>
        </li>
      )
    })
  }

  function mapeandoHistoricoAsplan() {
    if (arquivosHistorico.length === 0) {
      return semResultados()
    }

    return arquivosHistorico.map((v, k) => {
      return (
        <li key={k} className="list-unstyled">
          <a href="#">
            {v.titulo}
          </a>
        </li>
      )
    })
  }

  return (
    <PaginaLogada titulo={"Busca por - " + params.get('q')} isCarregando={isCarregando}>
      <Card titulo="Busca de projetos">
        <ul>
          {mapeandoProjetos()}
        </ul>
      </Card>

      <Card titulo="Busca de meta">
        <ul>
          {mapeandoMetas()}
        </ul>
      </Card>

      <Card titulo="Busca no histórico ASPLAN">
        <ul>
          {mapeandoHistoricoAsplan()}
        </ul>
      </Card>
    </PaginaLogada>
  );
}